import { render, staticRenderFns } from "./DeviceBorrow.vue?vue&type=template&id=5500c458&scoped=true&"
import script from "./DeviceBorrow.vue?vue&type=script&lang=js&"
export * from "./DeviceBorrow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5500c458",
  null
  
)

export default component.exports